import { Facebook, Instagram, Linkedin, Twitter, Music2 } from 'lucide-react';

export const NETWORKS = ['facebook', 'instagram', 'linkedin', 'x', 'tiktok'];

export const NETWORK_LABELS = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  x: 'X (Twitter)',
  tiktok: 'TikTok'
};

export const NETWORK_ICONS = {
  facebook: Facebook,
  instagram: Instagram,
  linkedin: Linkedin,
  x: Twitter,
  tiktok: Music2
};

export const NETWORK_COLORS = {
  facebook: '#1877F2',
  instagram: '#E4405F',
  linkedin: '#0A66C2',
  x: '#000000',
  tiktok: '#010101'
};
